
import React, { useState } from 'react';
import {Dropdown} from 'react-bootstrap';
import { A } from 'hookrouter';
import { DROPDOWN_ITEM_ACTIVE_DEALS, DROPDOWN_ITEM_ACTIVITIES, DROPDOWN_ITEM_AVAILABLE_CONSULTS, DROPDOWN_ITEM_BUSINESS_MODE, DROPDOWN_ITEM_FOLLOW_UP, DROPDOWN_ITEM_ORGANIZATIONS, DROPDOWN_ITEM_PEOPLE } from '../../../i18n/keyConstants';
import { useTranslation } from 'react-i18next';

const CrmNavMenuDropdown = ({ type }) => {
    const { t } = useTranslation(['crmNavMenuDropDown']);
    let activeTab;
    switch (type) {
        case 'CrmDeals':
            activeTab = t(DROPDOWN_ITEM_BUSINESS_MODE);
            break;
        case 'CrmDealDetails':
            activeTab = t(DROPDOWN_ITEM_BUSINESS_MODE);
            break;
        case 'CrmAvailableConsultants':
            activeTab = t(DROPDOWN_ITEM_AVAILABLE_CONSULTS);
            break;
        case 'CrmOrganizations':
            activeTab = t(DROPDOWN_ITEM_ORGANIZATIONS);
            break;
        case 'CrmOrganizationDetails':
            activeTab = t(DROPDOWN_ITEM_ORGANIZATIONS);
            break;
        case 'CrmPersons':
            activeTab = t(DROPDOWN_ITEM_PEOPLE);
            break;
        case 'CrmPersonDetails':
            activeTab = t(DROPDOWN_ITEM_PEOPLE);
            break;
        case 'CrmActivities':
            activeTab = t(DROPDOWN_ITEM_ACTIVITIES);
            break;
        case 'CrmActiveDeals':
            activeTab = t(DROPDOWN_ITEM_ACTIVE_DEALS);
            break;
        case 'CrmInsights':
            activeTab = t(DROPDOWN_ITEM_FOLLOW_UP);
            break;
        default:
            break;
    }

    return (
        <div className='padding-left-5px padding-right-5px'>
        <Dropdown>
            <Dropdown.Toggle id="dropdown-button-dark-example1" variant="secondary" className='bg-dark-blue' style={{WebkitTextStrokeWidth: '0.5px', border: 'none'}}>
            {activeTab}
            </Dropdown.Toggle>
            <Dropdown.Menu >
            <Dropdown.Item><A href='/crmDeals' style={{ textDecoration: 'none' }}>{t(DROPDOWN_ITEM_BUSINESS_MODE)}</A></Dropdown.Item>
            <Dropdown.Item><A href='/crmAvailableConsultants' style={{ textDecoration: 'none' }}>{t(DROPDOWN_ITEM_AVAILABLE_CONSULTS)}</A></Dropdown.Item>
            <Dropdown.Item><A href='/crmOrganizations' style={{ textDecoration: 'none' }}>{t(DROPDOWN_ITEM_ORGANIZATIONS)}</A></Dropdown.Item>
            <Dropdown.Item><A href='/crmPersons' style={{ textDecoration: 'none' }}>{t(DROPDOWN_ITEM_PEOPLE)}</A></Dropdown.Item>
            <Dropdown.Item><A href='/crmActivities' style={{ textDecoration: 'none' }}>{t(DROPDOWN_ITEM_ACTIVITIES)}</A></Dropdown.Item>
            <Dropdown.Item><A href='/crmActiveDeals' style={{ textDecoration: 'none' }}>{t(DROPDOWN_ITEM_ACTIVE_DEALS)}</A></Dropdown.Item>
            <Dropdown.Item><A href='/crmInsights' style={{ textDecoration: 'none' }}>{t(DROPDOWN_ITEM_FOLLOW_UP)}</A></Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
        </div>
    );
};

export default CrmNavMenuDropdown;